<div class="layout-wrapper layout-content-navbar" [class.menu-open]="menuOpen">
    <div class="layout-container">
        <!-- Menu -->

        <aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme layout-menu-expanded">
            <!-- Sidebar header: logo + close button -->
            <div class="app-brand demo sidebar-brand-row">
                <a class="app-brand-link pt-3 text-center justify-content-center">
                    <img src="../../../../assets/img/logo.png" alt="" srcset="" style="width: 60%">
                </a>
                <button class="btn sidebar-close-btn d-lg-none" (click)="closeMenu()" aria-label="Cerrar menú">
                    <i class="ti ti-x"></i>
                </button>
            </div>

            <div class="mt-4 mb-3">
                <div class="d-flex align-items-center justify-content-start px-4">
                    <div class="rounded bg-light d-flex align-items-center justify-content-center"
                        style="width:40px;height:40px;color:#00A3E0;font-weight:700;">
                        {{ userInitials }}
                    </div>
                    <div class="ms-2 lh-1" style="font-size: 18px; color: #545454; font-weight: 600;">
                        {{ roleLabel }}
                    </div>
                </div>
            </div>


            <ul class="menu-inner py-1 overflow-auto">

                <li class="menu-item" *ngFor="let item of permissions; let i = index"
                    [class.active]="isItemActive(item)"
                    [class.open]="isItemActive(item) || servicesOpen[i]">
                    <a [routerLink]="getRoute(item)" class="menu-link" *ngIf="item.children.length == 0">
                        <img src="../../../../assets/img/icons/{{ getIcon(item) }}" alt="" class="me-2">
                        <div>{{ getDisplayName(item) }}</div>
                    </a>
                    <a class="menu-link menu-toggle" *ngIf="item.children.length > 0" href="javascript:void(0)"
                        (click)="toggleServices($event, i)" role="button"
                        [attr.aria-expanded]="!!servicesOpen[i]">
                        <img src="../../../../assets/img/icons/{{ getIcon(item) }}" alt="" class="me-2">
                        <div>{{ getDisplayName(item) }}</div>
                        <i class="ti ti-chevron-down menu-chevron" [class.rotated]="servicesOpen[i]"></i>
                    </a>
                    <ul class="menu-sub" *ngIf="item.children.length > 0"
                        [style.display]="(servicesOpen[i] || isItemActive(item)) ? 'block' : null">
                        <li class="menu-item pe-2" *ngFor="let subItem of item.children"
                            [class.active]="isSubItemActive(subItem, item.children)">
                            <a [routerLink]="getRoute(subItem)" class="menu-link">
                                <img src="../../../../assets/img/icons/{{ getIcon(subItem) }}" alt="" class="me-2">
                                <div>{{ getDisplayName(subItem) }}</div>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="menu-item" *ngIf="dataUser?.role_id == 1" [class.open]="configOpen">
                    <a class="menu-link menu-toggle" href="javascript:void(0)" (click)="toggleConfiguration($event)"
                        role="button" [attr.aria-expanded]="configOpen">
                        <img src="../../../../assets/img/icons/wrench.svg" alt="" class="me-2">
                        <div>Configuración</div>
                        <i class="ti ti-chevron-down menu-chevron" [class.rotated]="configOpen"></i>
                    </a>
                    <ul class="menu-sub" [style.display]="configOpen ? 'block' : null">
                        <li class="menu-item pe-2" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">
                            <a [routerLink]="getRoute({route: 'setting.permissions'})" class="menu-link">
                                <img src="../../../../assets/img/icons/user-settings.svg" alt="" class="me-2">
                                <div>Permisos</div>
                            </a>
                        </li>
                        <li class="menu-item pe-2" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">
                            <a [routerLink]="getRoute({route: 'setting.notification-config'})" class="menu-link">
                                <img src="../../../../assets/img/icons/alert.svg" alt="" class="me-2">
                                <div>Configuración de Notificaciones</div>
                            </a>
                        </li>
                        <li class="menu-item pe-2" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">
                            <a [routerLink]="getRoute({route: 'setting.notification-logs'})" class="menu-link">
                                <img src="../../../../assets/img/icons/elements.svg" alt="" class="me-2">
                                <div>Logs de Notificaciones</div>
                            </a>
                        </li>
                        <li class="menu-item pe-2" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">
                            <a [routerLink]="getRoute({route: 'setting.whatsapp-config'})" class="menu-link">
                                <img src="../../../../assets/img/icons/comment.svg" alt="" class="me-2">
                                <div>Configuración de WhatsApp</div>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>

            <!-- Sidebar footer logout -->
            <div class="menu-footer">
                <a class="menu-link justify-content-end" href="javascript:void(0)" (click)="logout()">
                    <div style="color: #222222;">Cerrar sesión</div>
                    <img src="../../../../assets/img/icons/closed.svg" alt="" class="ms-2">
                </a>
            </div>


        </aside>
        <!-- / Menu -->

        <!-- Layout container -->
        <div class="layout-page">

            <!-- Mobile topbar (hamburger + logo, solo responsive) -->
            <nav class="mobile-topbar d-flex d-lg-none align-items-center justify-content-between px-3">
                <button class="btn hamburger-btn" (click)="toggleMenu()" aria-label="Abrir menú">
                    <span class="hamburger-icon">
                        <span></span><span></span><span></span>
                    </span>
                </button>
                <img src="../../../../assets/img/logo.png" alt="Logo" class="mobile-topbar-logo">
            </nav>

            <!-- Content wrapper -->
            <div class="content-wrapper">
                <!-- Content -->

                <div class="ps-4 pe-4 flex-grow-1 container-p-y">
                    <div class="card mb-4 d-none d-lg-block"
                         [class.dashboard-header--flat]="isInvoicingModule()">
                        <div class="card-body p-1 ps-4">
                            <div class="row">
                                <div class="col">
                                    <h4 class="py-3 mb-0">
                                        <span class="text-muted fw-light">
                                            <a *ngIf="dataChildren?.backRoute"
                                               [routerLink]="dataChildren.backRoute"
                                               [queryParams]="dataChildren.backParams"
                                               class="text-muted text-decoration-none">{{dataChildren.module}}</a>
                                            <ng-container *ngIf="!dataChildren?.backRoute">{{dataChildren.module}}</ng-container>
                                            /
                                        </span>
                                        {{dataChildren.accion}}
                                    </h4>
                                </div>
                                <div class="col text-end mb-0 pt-2 px-4" *ngIf="dataChildren?.type == 'list'">
                                    <a class="btn btn-outline-info btn-update"
                                       *ngIf="!isInvoicingModule()"
                                       (click)="refreshGrid('refresh')">
                                        <img src="../../../../assets/img/icons/elements.svg" alt="" class="me-2">
                                        Actualizar
                                    </a>
                                    <a class="btn btn-info btn-service btn-add dashboard-header__new-invoice"
                                       *ngIf="dataChildren?.module === 'Facturación'"
                                       routerLink="/invoicing/new">
                                        <i class="ti ti-plus"></i>
                                        Nueva Factura
                                    </a>

                                    <ng-container *ngIf="dataChildren?.module === 'Facturas de almacén'">
                                        <a class="btn btn-info btn-service btn-add dashboard-header__new-invoice"
                                           (click)="newWarehouseInvoice()">
                                            <i class="ti ti-plus"></i>
                                            Nueva Factura
                                        </a>

                                        <div class="warehouse-picker ms-3" [class.open]="warehouseOpen">
                                            <button type="button" class="warehouse-picker__toggle"
                                                    (click)="toggleWarehouse($event)"
                                                    [attr.aria-expanded]="warehouseOpen">
                                                <svg class="warehouse-picker__icon" viewBox="0 0 24 24" fill="none"
                                                     stroke="currentColor" stroke-width="1.7"
                                                     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                                    <path d="M3 21V9.5L12 3l9 6.5V21"/>
                                                    <path d="M2 21h20"/>
                                                    <rect x="9.75" y="11.5" width="4.5" height="4.5" rx="0.6"/>
                                                    <rect x="6" y="16.5" width="4.5" height="4.5" rx="0.6"/>
                                                    <rect x="13.5" y="16.5" width="4.5" height="4.5" rx="0.6"/>
                                                </svg>
                                                <span class="warehouse-picker__label">Almacén actual:</span>
                                                <span class="warehouse-picker__value">{{ currentWarehouse.name }}</span>
                                                <i class="ti ti-chevron-down warehouse-picker__chevron"></i>
                                            </button>

                                            <div class="warehouse-picker__menu" *ngIf="warehouseOpen">
                                                <p class="warehouse-picker__menu-title">Cambiar de almacén</p>
                                                <ul class="warehouse-picker__list">
                                                    <li *ngFor="let warehouse of sortedWarehouses">
                                                        <button type="button" class="warehouse-picker__option"
                                                                [class.selected]="warehouse === currentWarehouse"
                                                                (click)="selectWarehouse(warehouse)">
                                                            <span class="warehouse-picker__option-info">
                                                                <span class="warehouse-picker__option-name">
                                                                    {{ warehouse.name }}
                                                                    <span class="warehouse-picker__badge"
                                                                          *ngIf="warehouse === currentWarehouse">Actual</span>
                                                                </span>
                                                                <span class="warehouse-picker__option-address">{{ warehouse.address }}</span>
                                                            </span>
                                                            <span class="warehouse-picker__check"
                                                                  *ngIf="warehouse === currentWarehouse">
                                                                <i class="ti ti-check"></i>
                                                            </span>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <a class="btn btn-info btn-service ms-3 btn-add" routerLink="/service/add"
                                        *ngIf="canDo('Servicios Unificados','Crear') && dataChildren?.module == 'Servicio'">
                                        <i class="ti ti-plus"></i>
                                        Agregar servicio
                                    </a>
                                    <a class="btn btn-info btn-service ms-3 btn-add" routerLink="/client/add"
                                        *ngIf="canDo('Clientes','Crear') && dataChildren?.module == 'Cliente'">
                                        <i class="ti ti-plus"></i>
                                        Agregar Cliente
                                    </a>
                                    <a class="btn btn-info btn-service ms-3 btn-add" routerLink="/driver/add"
                                        *ngIf="canDo('Conductores','Crear') && dataChildren?.module == 'Conductor'">
                                        <i class="ti ti-plus"></i>
                                        Agregar Conductor
                                    </a>
                                    <a class="btn btn-info btn-service ms-3 btn-add" routerLink="/assistant/add"
                                        *ngIf="canDo('Auxiliares','Crear') && dataChildren?.module == 'Auxiliar'">
                                        <i class="ti ti-plus"></i>
                                        Agregar Auxiliar
                                    </a>
                                    <a class="btn btn-info btn-service ms-3 btn-add" routerLink="/unit/add"
                                        *ngIf="canDo('Unidades','Crear') && dataChildren?.module == 'Unidad'">
                                        <i class="ti ti-plus"></i>
                                        Agregar Unidad
                                    </a>
                                    <a class="btn btn-info btn-service ms-3 btn-add" routerLink="/trailer/add"
                                        *ngIf="canDo('Remolques','Agregar') && dataChildren?.module == 'Remolque'">
                                        <i class="ti ti-plus"></i>
                                        Agregar Remolque
                                    </a>
                                    <a class="btn btn-info btn-service ms-3 btn-add" routerLink="/carta-porte/add"
                                        *ngIf="canDo('Carta Porte','Crear') && dataChildren?.module == 'Carta Porte'">
                                        <i class="ti ti-plus"></i>
                                        Agregar Carta Porte
                                    </a>
                                    <a class="btn btn-info btn-service ms-3 btn-add" (click)="refreshGrid('add')"
                                        *ngIf="canDo('Cuentas de usuarios','Crear') && dataChildren?.module == 'Cuentas de Usuarios'">
                                        <i class="ti ti-plus"></i>
                                        Agregar usuario
                                    </a>
                                    <a class="btn btn-info btn-service ms-3 btn-add" routerLink="/maintenance/add"
                                        *ngIf="dataChildren?.module == 'Mantenimiento de unidades' && canDo('Mantenimiento de unidades','Crear')">
                                        <i class="ti ti-plus"></i>
                                        Crear reporte de falla
                                    </a>
                                </div>
                                <div class="col-lg-4 col-sm-12 text-end mb-0" *ngIf="dataChildren?.type == 'supplier'">
                                    <a class="btn btn-info btn-service ms-3 btn-add" (click)="refreshGrid('add')"
                                        *ngIf="dataChildren?.accion == 'Registro de proveedores' || dataChildren?.accion == 'Registro de refaccionarias o tiendas'">
                                        <i class="ti ti-plus"></i>
                                        Agregar otro proveedor
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>


                    <router-outlet></router-outlet>
                </div>
                <!-- / Content -->

                <!-- Footer -->
                <footer class="content-footer footer bg-footer-theme">
                    <div class="container-xxl">
                        <div
                            class="footer-container d-flex align-items-center justify-content-between py-2 flex-md-row flex-column">
                            <div>
                                ©
                                <script>
                                    document.write(new Date().getFullYear());
                                </script>
                                , Todos los derechos reservados
                            </div>
                        </div>
                    </div>
                </footer>
                <!-- / Footer -->
                <div class="content-backdrop fade"></div>
            </div>
            <!-- Content wrapper -->
        </div>
        <!-- / Layout page -->
    </div>

    <!-- Mobile overlay -->
    <div class="layout-overlay" [class.show]="menuOpen" (click)="closeMenu()"></div>
</div>

<!-- Notification Toast Component -->
<app-notification-toast></app-notification-toast>